module.exports = __webpack_public_path__ + "img/dependentsIcon.95cf4588.svg";